module.exports = __webpack_public_path__ + "img/text.b64463ff.png";